var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Communication/Bookmark/"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1626 2.39163C10.6871 1.42496 9.3132 1.42496 8.83768 2.39163L6.86219 6.40758L2.44484 7.05157C1.38156 7.20658 0.956991 8.51755 1.72639 9.27L4.92281 12.396L4.16824 16.8099C3.98661 17.8724 5.09814 18.6826 6.04917 18.181L10.0002 16.097L13.9512 18.181C14.9022 18.6826 16.0137 17.8724 15.8321 16.8099L15.0775 12.396L18.2739 9.27C19.0433 8.51755 18.6188 7.20658 17.5555 7.05157L13.1381 6.40758L11.1626 2.39163Z",
    fill: "#2D9BB2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOn);
export default __webpack_public_path__ + "static/media/BookmarkOn.4c8959f86198a164f827d1665f64cd49.svg";
export { ForwardRef as ReactComponent };